/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { IPage } from 'src/interfaces';
import { CommonDropdown, RegularButton, CommonInput, FullScreenLoading } from 'pg-ui-library';
import attachmentBlue from 'src/assets/attachment-blue.svg';
import ExpenseReceiptTable from 'src/components/expense-receipt-table';

import {
  MainContainer,
  TopBar,
  SearchLink,
  ViewHistory,
  InvoiceTitle,
  SubText,
  InfoGrid,
  InfoRow,
  Label,
  Value,
  Status,
  StatusDot,
  Divider,
  AmountGrid,
  NotesBox,
  Attachment,
  AttachmentIcon,
} from './viewstyles';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import ExpenseService from 'src/services/expense.service';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ExpenseRejectionModal } from './modals/rejectModal';
import { ExpenseSubmmisionModal } from './modals/approveModal';
import { ExpenseDeleteModal } from './modals/deleteExpense';

import { da } from 'date-fns/locale';
// import { formatCurrency } from 'src/utils/currencyFormat';
// import { formatDecimal } from 'src/utils/units';

export const formatPeriodDate = (dateStr: string): string => {
  const date = new Date(dateStr);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

const formatToMMDDYYYY = (dateString?: string | null): string => {
  if (!dateString) return '';

  const [year, month, day] = dateString.split('-');
  return `${month}/${day}/${year}`;
};

const ViewExpense: React.FC<IPage> = props => {
  const [isOpenDelete, setIsOpenDelete] = useState<boolean>(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { expenseId } = useParams<{ expenseId: string }>();

  const { isFetching, data, refetch } = useQuery(['expense-details'], async () => {
    const result = await ExpenseService.getExpenseDetails({ expenseId: expenseId });
    return result.data;
  });

  const getExpenseDetails = data;

  const expenseStatus = getExpenseDetails?.status?.toLowerCase?.() || '';
  const [isDownloading, setIsDownloading] = useState(false);

  const isApproved = expenseStatus === 'approved';
  const isRejected = expenseStatus === 'rejected';

  const isDraft = expenseStatus === 'draft';
  const isSubmitted = expenseStatus === 'submitted';

  // const isCompleted = expenseStatus === 'completed';
  const isCompleted =
    expenseStatus === 'completed' || expenseStatus === 'pay_processed' || expenseStatus === 'bill_processed';

  const ResubmitExpense = (expenseId: any) => {
    navigate(`/expenses/${expenseId}/edit?action=resubmit`);
  };

  const OverrideExpense = (expenseId: any) => {
    navigate(`/expenses/${expenseId}/override`);
  };

  const handleBackClick = () => {
    navigate('/expenses');
  };

  const DeleteExpense = (expenseId: any) => {
    setIsOpenDelete(true);
  };

  const [showFun, setShowFun] = useState(true);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenReject, setIsOpenReject] = useState<boolean>(false);
  const [userRole] = useLocalStorage('userRole', null);

  const accessAdmin = localStorage.getItem('userAccessAdmin');
  const adminPermissions = accessAdmin ? JSON.parse(accessAdmin) : [];

  const hasOverridePermission = adminPermissions.some(
    (permission: any) => permission.adminPermissionId === 'admin_override_permission'
  );
  console.log('hasOverridePermission', hasOverridePermission);
  // useEffect(() => {
  //   if (userRole === 'external_manager') {
  //     setShowFun(false);
  //   } else {
  //     setShowFun(true);
  //   }
  // }, [userRole]);

  const statusMapping = (status?: string | null): string => {
    if (!status) return '';

    const mapping: Record<string, string> = {
      pay_processed: 'Pay Processed',
      bill_processed: 'Bill Processed',
      rejected: 'Rejected',
      draft: 'Draft',
      submitted: 'Submitted',
      approved: 'Approved',
      completed: 'Completed',
    };

    return mapping[status.toLowerCase()] ?? status;
  };

  const ApproveExpense = (expenseId: any) => {
    setIsOpen(true);
  };
  const RejectExpense = (expenseId: any) => {
    setIsOpenReject(true);
  };

  const EditExpense = (expenseId: any = '') => {
    navigate(`/expenses/${expenseId}/edit`);
  };

  const isLockedStatus =
    data?.status?.toLocaleLowerCase() === 'approved' ||
    data?.status?.toLocaleLowerCase() === 'pay_processed' ||
    data?.status?.toLocaleLowerCase() === 'bill_processed';
  let expenses = data?.receipts || [];
  const status = data?.status?.toLowerCase() || '';

  return (
    <MainContainer>
      {isFetching && <FullScreenLoading />}
      <ExpenseSubmmisionModal isOpen={isOpen} setIsOpen={setIsOpen} expenseDetail={getExpenseDetails} />
      <ExpenseRejectionModal isOpen={isOpenReject} setIsOpen={setIsOpenReject} expenseDetail={getExpenseDetails} />
      <ExpenseDeleteModal isOpen={isOpenDelete} setIsOpen={setIsOpenDelete} expenseDetail={getExpenseDetails} />

      <TopBar>
        <SearchLink>
          <Link to={`/expenses`}>Search Expenses</Link>
        </SearchLink>

        <div style={{ display: 'flex', gap: '12px' }}>
          <ViewHistory style={{ marginTop: '14px' }}>
            <Link to={`/expenses/${expenseId}/history`}>View History</Link>
          </ViewHistory>
          {/* <RegularButton onClick={handleDownload}>Download PDF</RegularButton> */}
        </div>
      </TopBar>

      <InvoiceTitle>Week Ending {data?.weekEnd && formatPeriodDate(data.weekEnd)}</InvoiceTitle>
      <SubText>{data?.employeeName}</SubText>

      <InfoGrid>
        <InfoRow>
          <Label>Status</Label>
          <Value>
            <Status>{statusMapping(data?.status)}</Status>
          </Value>
        </InfoRow>

        <InfoRow>
          <Label>Client</Label>
          <Value>{data?.clientName}</Value>
        </InfoRow>

        <InfoRow>
          <Label>Expense ID</Label>
          <Value>
            {data?.expenseShowId} {`(Version ${data?.version})`}
          </Value>
        </InfoRow>

        <InfoRow>
          <Label>Assignment</Label>
          <Value>{data?.assignmentName}</Value>
        </InfoRow>

        <InfoRow>
          <Label>Approver</Label>
          <Value>{data?.managerName}</Value>
        </InfoRow>

        <InfoRow>
          <Label>Backup Approver</Label>
          <Value>{data?.coApproverName}</Value>
        </InfoRow>
        <InfoRow>
          {data?.rejectedDate ? (
            <>
              <Label>Rejected At</Label>
              <Value style={{ color: 'red' }}>
                {formatPeriodDate(data?.rejectedDate)} by {data?.rejectedby}{' '}
              </Value>
            </>
          ) : data?.approvedby ? (
            <>
              <Label>Approved At</Label>
              <Value>
                {formatToMMDDYYYY(data?.approvedDate)} by {data?.approvedby}{' '}
              </Value>
            </>
          ) : null}
        </InfoRow>
      </InfoGrid>

      <div style={{ padding: '40px' }}>
        <ExpenseReceiptTable expenses={expenses} currency={data?.currency || 'USD'} />
      </div>

      <Label>Notes</Label>
      <NotesBox value={data?.notes || ''} />

      <Label style={{ marginTop: '24px' }}>Attachments</Label>
      <div>
        <p style={{ fontSize: '1.4rem' }}>
          {data?.attachments && data.attachments.length > 0 && (
            <img src={attachmentBlue} alt="Formatting Icon" style={{ height: '17px', margin: '0px 10px 0px 2px' }} />
          )}
          {data?.attachments &&
            data?.attachments.length > 0 &&
            data?.attachments.map((attachment, index) => (
              <React.Fragment key={index}>
                <a href={attachment.attachmentUrl} target="_blank" rel="noopener noreferrer">
                  {attachment.attachmentName}
                </a>
                {index < (data?.attachments || []).length - 1 && ', '}
              </React.Fragment>
            ))}
        </p>
      </div>

      <Divider />
      <>
        {isDraft ? (
          <>
            <RegularButton onClick={() => EditExpense(expenseId)}>Edit Expense</RegularButton>
            {hasOverridePermission && (
              <RegularButton onClick={() => OverrideExpense(expenseId)}>Override Expense</RegularButton>
            )}
            <RegularButton onClick={() => DeleteExpense(expenseId)}>Delete Expense</RegularButton>
          </>
        ) : isCompleted ? (
          <>
            <RegularButton onClick={() => ResubmitExpense(expenseId)}>Resubmit Expense</RegularButton>
            {hasOverridePermission && (
              <RegularButton onClick={() => OverrideExpense(expenseId)}>Override Expense</RegularButton>
            )}
            <RegularButton onClick={() => DeleteExpense(expenseId)}>Delete Expense</RegularButton>
          </>
        ) : (
          <>
            {!isApproved && <RegularButton onClick={() => EditExpense(expenseId)}>Edit Expense</RegularButton>}
            {!isRejected && <RegularButton onClick={() => RejectExpense(expenseId)}>Reject Expense</RegularButton>}
            {!isApproved && <RegularButton onClick={() => ApproveExpense(expenseId)}>Approve Expense</RegularButton>}

            {isApproved && <RegularButton onClick={() => ResubmitExpense(expenseId)}>Resubmit Expense</RegularButton>}

            {hasOverridePermission && (
              <RegularButton onClick={() => OverrideExpense(expenseId)}>Override Expense</RegularButton>
            )}
            <RegularButton onClick={() => DeleteExpense(expenseId)}>Delete Expense</RegularButton>
          </>
        )}
      </>
    </MainContainer>
  );
};

export default ViewExpense;
